import { NavigationProvider } from '@web/navigation/NavigationProvider';
import { NavigateAction } from '@web/navigation/navigationProvider.types';
import ICalAnnouncement from '@web/shifts/ICalAnnouncement/ICalAnnouncement';

const ICalAnnouncementAngular = ({ currentUser, stateService, saveClientFlags }) => {
  const navigate: NavigateAction = (path, params, options) => {
    stateService.go(path, params, options);
  };

  return (
    <NavigationProvider navigate={navigate}>
      <ICalAnnouncement currentUser={currentUser} saveClientFlags={saveClientFlags} />
    </NavigationProvider>
  );
};

export default {
  ReactComponent: ICalAnnouncementAngular,
  bindings: {
    currentUser: '<',
    stateService: '<',
    saveClientFlags: '<',
  },
};
